// Ozera sticky mobile add-to-cart. Shows once the hero ATC button scrolls out of view above the
// fold; the sticky button proxies a click to the real hero submit button so product-form.js still
// owns the actual add-to-cart request.
(function () {
  var sticky = document.querySelector('[data-oz-sticky]');
  var heroAtc = document.querySelector('[data-oz-hero-atc]');
  if (!sticky || !heroAtc) return;

  var stickyBtn = sticky.querySelector('[data-oz-sticky-add]');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      heroAtc.click();
    });
  }

  var observer = new IntersectionObserver(
    function (entries) {
      var entry = entries[0];
      sticky.dataset.show = !entry.isIntersecting ? 'true' : 'false';
      stickyBtn.disabled = heroAtc.disabled || heroAtc.getAttribute('aria-disabled') === 'true';
    },
    { threshold: 0 }
  );
  observer.observe(heroAtc);
  new MutationObserver(function () {
    stickyBtn.disabled = heroAtc.disabled || heroAtc.getAttribute('aria-disabled') === 'true';
  }).observe(heroAtc, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
})();
